import { Message, SpecialOffer } from '../../../PdpProductProvider/types';
import { parseSpecialOffer } from './parseSpecialOffer';

export const getSpecialOffersFromMessages = (
  messages?: Array<Message>,
  storeTimeZone?: string
): Array<SpecialOffer> => {
  const specialOffers: Array<SpecialOffer> = [];
  messages?.forEach(message => {
    if (!['Services', 'SpecialOffers'].includes(message.type) || ['Installation'].includes(message.subType)) return null;

    specialOffers.push(parseSpecialOffer(message, storeTimeZone));
  });
  return specialOffers;
};
